<template>
  <el-popover placement="bottom-end" :width="width" trigger="hover" popper-class="popover-vip" @show="getEquityInfo">
    <div>
      <div style="padding: 14px 12px;border-bottom: 1px solid #F2F2F2;">
        <div><b>企业权益</b></div>
        <div class="mt-10">到期时间：{{ $store.state.user.closeDate&&$store.state.user.closeDate.substring(0,10) }}</div>
      </div>
      <div style="padding: 14px 12px;">
        <p>企业权益总条数<span class="fr">{{ $store.state.user.usedTotal }} / {{ $store.state.user.total }}</span></p>
      </div>
    </div>
    <img src="~@/assets/newicons/vip.svg" slot="reference" class="img-vip" />
  </el-popover>
</template>

<script>
import { cueQuotaStatistics } from '@/views/home/api'
export default {
  name: 'corporateEquity',
  props: {
    width: {
      default: '240'
    }
  },
  data() {
    return {};
  },
  components: {

  },
  computed: {

  },
  watch: {},
  methods: {
    getEquityInfo() {
      cueQuotaStatistics().then(res => {
        if (res.code == 200) {
          const surplus = res.data.companyInterest.total - res.data.companyInterest.usedTotal
          this.$store.commit('SET_CLOSEDATE', res.data.closeDate || '--')
          this.$store.commit('SET_SURPLUS', surplus)
          this.$store.commit('SET_USEDTOTAL', res.data.companyInterest.usedTotal)
          this.$store.commit('SET_TOTAL', res.data.companyInterest.total)
          // console.log('cueQuotaStatistics', surplus)
        }
      })
    }

  },

  mounted() { }

}

</script>

<style scoped>
.img-vip {
  position: absolute;
  top: 25px;
  right: 39px;
  z-index: 9;
}
</style>
